
import React from 'react';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import VirtualCareSection from './components/VirtualCareSection';
import TreatmentsSection from './components/TreatmentsSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';

const HomePage: React.FC = () => {
  return (
    <div>
      <HeroSection />
      <VirtualCareSection />
      <ServicesSection />
      <TreatmentsSection />
      <AboutSection />
      <ContactSection />
    </div>
  );
};

export default HomePage;
